import * as d3 from 'd3';
import { interpolateBlues } from 'd3-scale-chromatic';

import * as R from 'ramda';
import React from 'react';
import PropTypes from 'prop-types';

class PieChartComponent extends React.Component {
  constructor (props) {
    super(props);

    this.createPieChart = () => {
      if (!this.props.canvasWidth || !this.props.canvasHeight) {
        return;
      }

      const { sectors } = this.props;

      const width = this.props.canvasWidth;
      const height = this.props.canvasHeight;

      const radius = Math.min(width, height) / 2;

      const arc = d3.arc().outerRadius(radius - 10).innerRadius(0);
      const labelArc = d3.arc().outerRadius(radius - 60).innerRadius(radius - 60);

      const pie = d3.pie().sort(null).value(R.prop('count'));

      const color = d3.scaleSequential(interpolateBlues).domain([0, sectors.length]);

      const svg = d3
        .select(this.node)
        .select('#container')
        .attr('transform', `translate(${width / 2}, ${height / 2})`);

      svg.selectAll('.arc').remove();

      const g = svg.selectAll('.arc').data(pie(sectors)).enter().append('g').attr('class', 'arc');

      g.append('path').attr('d', arc).attr('fill', (_, i) => color(i));

      g
        .append('text')
        .attr('dy', '.35em')
        .attr('transform', d => `translate(${labelArc.centroid(d)})`)
        .text(({ data: { name, count } }) => `${name} (${count})`);
    };
  }

  componentDidMount () {
    this.createPieChart();
  }

  componentDidUpdate () {
    this.createPieChart();
  }

  render () {
    return (
      <svg
        width={this.props.canvasWidth}
        height={this.props.canvasHeight}
        ref={node => (this.node = node)}
      >
        <g id="container" data-testid="pie-chart" />
      </svg>
    );
  }
}

PieChartComponent.propTypes = {
  sectors: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired
    }).isRequired
  ).isRequired,

  canvasWidth: PropTypes.number,
  canvasHeight: PropTypes.number
};

export default PieChartComponent;
